/* Pack picker (snippets/silt-pack-picker.liquid): a pack radio sets the
   variant id the form posts and the price on the button. Delegated, so any
   number of pickers on a page share one listener. Also tells anything that
   mirrors the picker (the product page's sticky bar) via 'silt:pack'. */
(function () {
  if (window.__siltPP) return;
  window.__siltPP = true;
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.classList || !radio.classList.contains('silt-pp__radio')) return;
    var pp = radio.closest('[data-silt-pp]');
    if (!pp) return;
    var id = pp.querySelector('[data-silt-pp-id]');
    var price = pp.querySelector('[data-silt-pp-price]');
    if (id) id.value = radio.value;
    if (price) price.textContent = radio.getAttribute('data-price');
    var was = pp.querySelector('[data-silt-pp-was]');
    var wasV = pp.querySelector('[data-silt-pp-was-v]');
    if (was && wasV) {
      var mrp = radio.getAttribute('data-compare') || '';
      wasV.textContent = mrp;
      was.hidden = !mrp;
    }
    pp.dispatchEvent(new CustomEvent('silt:pack', {
      bubbles: true,
      detail: { id: radio.value, price: radio.getAttribute('data-price'), label: (radio.parentNode.querySelector('.silt-pp__size') || {}).textContent }
    }));
  });
})();
